import React, { HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';

import { View } from '@uncinc/react-drupal-core';
import type {
  ImmutableEntity,
  ParagraphEntity,
} from '@uncinc/react-drupal-core/types';
import { Container } from '@uncinc/uncinc-react-kitchen-sink';

interface ParagraphArticlesOverviewProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<ParagraphEntity>;
}

const ParagraphArticlesOverview: React.FC<ParagraphArticlesOverviewProps> = () => {
  const { t } = useTranslation();

  return (
    <div className="Paragraph ParagraphArticlesOverview">
      <Container>
        <h2 className="visually-hidden">{t('content_types.article.subheading')}</h2>
        <View
          id="article"
          display="overview"
          storageType="url"
          withProvider
        />
      </Container>
    </div>
  );
};

export default ParagraphArticlesOverview;
